import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel, RDTBrandOptions } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.National:
      case UserLevel.Province:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Wilayah</th>
                <th>Jum fasyankes melapor</th>
                <th>Jum fasyankes pemeriksaan mikroskopis</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Jum fasyankes pemeriksaan RDT</th>
                <th>Jum fasyankes SPO pembersihan dan penyimpanan kaca objek</th>
                <th>Jum fasyankes SPO pembuatan sediaan darah</th>
                <th>Jum fasyankes SPO pewarnaan sediaan darah</th>
                <th>
                  Jum fasyankes SPO pembacaan dan pelaporan hasil sediaan darah
                  malaria
                </th>
                <th>Jum fasyankes SPO uji kualitas giemsa</th>
                <th>Jum fasyankes SPO uji kualitas minyak imersi</th>
                <th>Jum fasyankes SPO uji kualitas methanol</th>
                <th>Jum fasyankes SPO uji kualitas pH buffer</th>
                <th>Jum fasyankes SPO penggunaan dan perawatan mikroskop</th>
                <th>Jum fasyankes SPO pelaksanaan K3</th>
                <th>Jum fasyankes SPO uji RDT</th>
                <th>Jum merk RDT yang digunakan (non lainnya)</th>
                <th>Jum merk RDT lainnya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.wilayah}</td>
                    <td>{item?.faskes_lapor}</td>
                    <td>{item?.priksa_mikros2}</td>
                    <td>{item?.jum_mikros_baik2}</td>
                    <td>{item?.keg_prksa_rdt2}</td>
                    <td>{item?.spo_kaca_objek2}</td>
                    <td>{item?.spo_pmbtn_darah2}</td>
                    <td>{item?.spo_pwrn_darah2}</td>
                    <td>{item?.spo_pbcn_darah2}</td>
                    <td>{item?.spo_giemsa2}</td>
                    <td>{item?.spo_imersi2}</td>
                    <td>{item?.spo_methanol2}</td>
                    <td>{item?.spo_phbuffer2}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros2}</td>
                    <td>{item?.spo_k3malaria2}</td>
                    <td>{item?.spo_rdt2}</td>
                    <td>{item?.rdtnonlainnya}</td>
                    <td>{item?.rdtlainnya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={19}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("faskes_lapor")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("priksa_mikros2")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jum_mikros_baik2")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("keg_prksa_rdt2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_kaca_objek2")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pmbtn_darah2")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_pwrn_darah2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_pbcn_darah2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_giemsa2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_imersi2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_methanol2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_phbuffer2")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pgunaan_prwtan_mikros2")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_k3malaria2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_rdt2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("rdtnonlainnya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("rdtlainnya")}</td>
              </tr>
            </tbody>
          </>
        );
      case UserLevel.District:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Wilayah</th>
                <th>Melapor (1=Melaporkan, 0=Tidak Melaporkan)</th>
                <th>Pemeriksaan mikroskopis (1=Ya, 0=Tidak)</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Pemeriksaan RDT (1=Ya, 0=Tidak)</th>
                <th>
                  SPO pembersihan dan penyimpanan kaca objek (1=Ya, 0=Tidak)
                </th>
                <th>SPO pembuatan sediaan darah (1=Ya, 0=Tidak)</th>
                <th>SPO pewarnaan sediaan darah (1=Ya, 0=Tidak)</th>
                <th>
                  SPO pembacaan dan pelaporan hasil sediaan darah malaria (1=Ya,
                  0=Tidak)
                </th>
                <th>SPO uji kualitas giemsa (1=Ya, 0=Tidak)</th>
                <th>SPO uji kualitas minyak imersi (1=Ya, 0=Tidak)</th>
                <th>SPO uji kualitas methanol (1=Ya, 0=Tidak)</th>
                <th>SPO uji kualitas pH buffer (1=Ya, 0=Tidak)</th>
                <th>SPO penggunaan dan perawatan mikroskop (1=Ya, 0=Tidak)</th>
                <th>SPO pelaksanaan K3 (1=Ya, 0=Tidak)</th>
                <th>SPO uji RDT (1=Ya, 0=Tidak)</th>
                <th>Merek RDT yang digunakan</th>
                <th>Merek RDT lainnya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.faskes_lapor}</td>
                    <td>{item?.priksa_mikros2}</td>
                    <td>{item?.jum_mikros_baik}</td>
                    <td>{item?.keg_prksa_rdt2}</td>
                    <td>{item?.spo_kaca_objek2}</td>
                    <td>{item?.spo_pmbtn_darah2}</td>
                    <td>{item?.spo_pwrn_darah2}</td>
                    <td>{item?.spo_pbcn_darah2}</td>
                    <td>{item?.spo_giemsa2}</td>
                    <td>{item?.spo_imersi2}</td>
                    <td>{item?.spo_methanol2}</td>
                    <td>{item?.spo_phbuffer2}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros2}</td>
                    <td>{item?.spo_k3malaria2}</td>
                    <td>{item?.spo_rdt2}</td>
                    <td>
                      {item?.nama_rdt
                        ? item?.nama_rdt
                        : RDTBrandOptions.find(
                            (opt) => opt.value === item?.kd_rdt
                          )?.label || null}
                    </td>
                    <td>{item?.merk_rdt_lain}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={19}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("faskes_lapor")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("priksa_mikros2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("jum_mikros_baik")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("keg_prksa_rdt2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_kaca_objek2")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pmbtn_darah2")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_pwrn_darah2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_pbcn_darah2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_giemsa2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_imersi2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_methanol2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_phbuffer2")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pgunaan_prwtan_mikros2")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_k3malaria2")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_rdt2")}</td>
                <td style={{ color: "#FFF" }}>-</td>
                <td style={{ color: "#FFF" }}>-</td>
              </tr>
            </tbody>
          </>
        );
      default:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Wilayah</th>
                <th>Pemeriksaan mikroskopis</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Melaksanakan pemeriksaan RDT</th>
                <th>SPO pembersihan dan penyimpanan kaca objek</th>
                <th>SPO pembuatan sediaan darah</th>
                <th>SPO pewarnaan sediaan darah</th>
                <th>SPO pembacaan dan pelaporan hasil sediaan darah malaria</th>
                <th>SPO uji kualitas giemsa</th>
                <th>SPO uji kualitas minyak imersi</th>
                <th>SPO uji kualitas methanol</th>
                <th>SPO uji kualitas pH buffer</th>
                <th>SPO penggunaan dan perawatan mikroskop</th>
                <th>SPO pelaksanaan K3</th>
                <th>SPO uji RDT</th>
                <th>Merek RDT yang digunakan</th>
                <th>Merek RDT lainnya</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.priksa_mikros}</td>
                    <td>{item?.jum_mikros_baik}</td>
                    <td>{item?.keg_prksa_rdt}</td>
                    <td>{item?.spo_kaca_objek}</td>
                    <td>{item?.spo_pmbtn_darah}</td>
                    <td>{item?.spo_pwrn_darah}</td>
                    <td>{item?.spo_pbcn_darah}</td>
                    <td>{item?.spo_giemsa}</td>
                    <td>{item?.spo_imersi}</td>
                    <td>{item?.spo_methanol}</td>
                    <td>{item?.spo_phbuffer}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros}</td>
                    <td>{item?.spo_k3malaria}</td>
                    <td>{item?.spo_rdt}</td>
                    <td>
                      {item?.nama_rdt
                        ? item?.nama_rdt
                        : RDTBrandOptions.find(
                            (opt) => opt.value === item?.kd_rdt
                          )?.label || null}
                    </td>
                    <td>{item?.merk_rdt_lain}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={18}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>
                SISMAL v4, Laporan Data Dasar Laboratorium Pemeriksaan Malaria
              </h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
